var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMobilePhoneGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H2C0.897 0 0 0.897 0 2V18C0 19.103 0.897 20 2 20H12C13.103 20 14 19.103 14 18V2C14 0.897 13.103 0 12 0ZM2 14.999V3H12L12.002 14.999H2Z",
    fill: "#9AA2B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobilePhoneGrey);
export default __webpack_public_path__ + "static/media/icon_mobile_phone_grey.f990996adac81b34a41e91a3d274fbef.svg";
export { ForwardRef as ReactComponent };